<ng-container *ngIf="voucher$ | async as voucher">
  <div class="soft-card">
    <div class="g gtc-2 gtc-m-4 gtr-4">
      <label class="soft-label left gr-1 gc-1">{{
        '#UPLOAD_ARCHIVE_VOUCHER.UPLOAD_PICTURE.NUMBER' | translate
      }}</label>
      <span class="gr-1 gc-2 gc-m-2-4">{{ voucher.belegnummer }}</span>

      <label class="soft-label left gr-2 gc-1">{{
        '#UPLOAD_ARCHIVE_VOUCHER.UPLOAD_PICTURE.DATE' | translate
      }}</label>
      <span class="gr-2 gc-2 gc-m-2-4">{{
        voucher.belegdatum | format: 'DD.MM.YYYY'
      }}</span>

      <label class="soft-label left gr-3 gc-1">{{
        '#UPLOAD_ARCHIVE_VOUCHER.UPLOAD_PICTURE.NAME' | translate
      }}</label>
      <span class="gr-3 gc-2 gc-m-2-4">{{ voucher.belegname }}</span>

      <label class="soft-label left gr-4 gc-1">{{
        '#UPLOAD_ARCHIVE_VOUCHER.UPLOAD_PICTURE.CUSTOMER' | translate
      }}</label>
      <span class="gr-4 gc-2 gc-m-2-4"
        >{{ voucher.kunde.nummer }} - {{ voucher.kunde.name1 }}
        {{ voucher.kunde.name2 }}</span
      >
    </div>
  </div>
  <div class="soft-overline mt-4">
    {{ '#UPLOAD_ARCHIVE_VOUCHER.UPLOAD_PICTURE.UPLOAD' | translate }}
  </div>
  <div class="soft-card">
    <div class="c row center">
      <soft-file-input
        [selectionMode]="'multi'"
        [sources]="'photo'"
        [progress]="(uploadState$ | async) ?? []"
        #images
      ></soft-file-input>
    </div>
    <div *ngIf="images.value.length > 0" class="c row buttons no-wrap mt-4">
      <button
        class="soft-button primary"
        [disabled]="loading$ | async"
        (click)="onUpload(voucher.archiveKey, images.value)"
      >
        <i *ngIf="loading$ | async" class="fa-regular fa-spinner fa-spin"></i>
        {{ '#APPLICATION.UPLOAD.SUBMIT' | translate }}
      </button>
    </div>
  </div>
</ng-container>
